// Can't default export enums
// eslint-disable-next-line import/prefer-default-export
export enum FeatureFlags {
  fileExchangeEnabled = 'file-exchange-enabled',
  outcomeTrackerEnabled = 'outcome-tracker-enabled',
  hmrcDataToggleEnabled = 'hmrc-data-toggle-enabled',
}
